import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { DfpComponent } from "../../ads/dfp-component";
import LeftSection from "./left-section/LeftSection";
import MiddleSection from "./middle-section/MiddleSection";
import GCCGoldRates from "./middle-section/GCCGoldRates";
import RightSection from "./right-section/RightSection";
import { getMenuGroups } from "../../../../api/utils";
import { useDeviceType } from "../../custom-hooks/useDeviceType";

import "./forex-page.m.css";

export const ForexPage = (props) => {
  // const menuItems = ["Remittance", "Gold Rate", "Fuel Price", "Currency"];
  // const sectionIds = ["remittance", "gold-rate", "fuel-price", "currency"];

  const qtConfig = useSelector((state) => get(state, ["qt"], {}));
  const domain = get(qtConfig, ["currentPath"], "");
  const baseUrl = useSelector((state) => get(state, ["qt", "config", "sketches-host"], ""));

  const [menuGroupsList, setMenuGroupsList] = useState([]);
  const sectionMenuList = menuGroupsList?.["menu-groups"]?.["main-nav"]?.items || [];
  const coverImage = get(props, ["data", "collection", "metadata", "cover-image"], null);
  const centerBottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "gold_forex_center_bottom_ad"], {})
  );

  const getCountryDetails = () => {
    const cleanUrl = domain?.split("?")[0];
    const segments = cleanUrl?.split("/").filter(Boolean);
    const slug = segments.pop();
    const urlToCountryCode = {
      "oman-gold-prices": { code: "omn", name: "Oman", currency: "OMR" },
      "saudi-gold-prices": { code: "sau", name: "Saudi", currency: "SAR" },
      "qatar-gold-prices": { code: "qat", name: "Qatar", currency: "QAR" },
      "kuwait-gold-prices": { code: "kwd", name: "Kuwait", currency: "KWD" },
      "bahrain-gold-prices": { code: "bah", name: "Bahrain", currency: "BHD" },
    };
    if (urlToCountryCode[slug]) return urlToCountryCode[slug];
    return { code: "uae", name: "UAE" };
  };

  const countryDetails = getCountryDetails();
  const countryCode = countryDetails.code;
  const isUAE = countryCode === "uae";
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  const getMenuItemsAndSections = () => {
    if (isUAE) {
      return {
        menuItems: ["Remittance", "Gold Rate", "Fuel Price", "Currency"],
        sectionIds: ["remittance", "gold-rate", "fuel-price", "currency"],
      };
    } else {
      // Different menu items for non-UAE countries
      return {
        menuItems: ["Live Rates", "Historical Rates"],
        sectionIds: ["live-gold-rates", "historical-gold-rates"],
      };
    }
  };

  const { menuItems, sectionIds } = getMenuItemsAndSections();

  useEffect(() => {
    const fetchMenuGroups = async () => {
      try {
        const menuGroups = await getMenuGroups();
        setMenuGroupsList(menuGroups);
      } catch (error) {
        console.error("Error fetching menu groups:", error);
      }
    };

    fetchMenuGroups();
  }, []);

  // Conditionally render the middle section component
  const renderMiddleSection = () => {
    if (isUAE) {
      return <MiddleSection apiData={{ allApiData: props?.data }} />;
    } else {
      return (
        <GCCGoldRates
          country={countryDetails.name}
          currency={countryDetails.currency}
          apiData={{ allApiData: props?.data }}
        />
      );
    }
  };

  const MiddleSectionList = renderMiddleSection();
  return (
    <div styleName="forex-page-container">
      <div styleName="forex-page-wrapper">
        <div styleName="forex-page-left-center-container">
          <div styleName="forex-page-left-container">
            <LeftSection menuItems={menuItems} sectionIds={sectionIds} />
          </div>
          <div styleName="forex-page-center-container">{MiddleSectionList}</div>
        </div>
        <div styleName="forex-page-right-container">
          <RightSection />
        </div>
      </div>

      {isDesktop && (
        <div>
          <div styleName="right-bottom-add-wrraper">
            <DfpComponent
              adStyleName="ad-slot-size-gold-forex-970x250"
              id="forex-page-bottom-ad"
              path={"/1019334/GULFNEWS/Gulfnews_BTF/gulfnews_goldforex_btf/gulfnews_goldforex_btf_footer"}
              size={centerBottomAdConfig.sizes}
              viewPortSizeMapping={centerBottomAdConfig.view_port_size_mapping}
            />
          </div>
        </div>
      )}
    </div>
  );
};
